///
/// EarthBrowser
///
/// Migration v48 to v49: Add clock playback options and time zone mode
/// Created by Matt Giger on 10/11/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v48 to v49
 *
 * Changes:
 * - earthbrowser.clockLoop (default true): animation wraps at the window end
 * - earthbrowser.clockFitToData (default false): clamp animation to the
 *   span the visible time-based layers cover
 * - earthbrowser.timeZoneMode (default "local"): clock display/edit zone
 */
export function migrateV48toV49(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object" || !s.earthbrowser) return state

	const eb = s.earthbrowser as Record<string, unknown>
	return {
		...s,
		earthbrowser: {
			...eb,
			clockLoop: typeof eb.clockLoop === "boolean" ? eb.clockLoop : true,
			clockFitToData: typeof eb.clockFitToData === "boolean" ? eb.clockFitToData : false,
			timeZoneMode: eb.timeZoneMode === "utc" ? "utc" : "local",
		},
	}
}
